import { createRouter, createWebHashHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

// 路由配置
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { 
      title: '登录',
      requiresAuth: false 
    }
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '控制台' }
      },
      {
        path: '/phones',
        name: 'PhonesManage',
        component: () => import('@/views/phones/PhonesManage.vue'),
        meta: { title: '手机管理' }
      },
      {
        path: '/sim-cards',
        name: 'SimCardsManage',
        component: () => import('@/views/simCards/SimCardsManage.vue'),
        meta: { title: '手机卡管理' }
      },
      {
        path: '/real-persons',
        name: 'RealPersonsManage',
        component: () => import('@/views/realPersons/RealPersonsManage.vue'),
        meta: { title: '关联实名人' }
      },
      {
        path: '/douyin-accounts',
        name: 'DouyinAccountsManage',
        component: () => import('@/views/douyin/DouyinAccountsManage.vue'),
        meta: { title: '抖音号管理' }
      },
      {
        path: '/douyin-logs',
        name: 'DouyinLogsManage',
        component: () => import('@/views/douyin/DouyinLogsManage.vue'),
        meta: { title: '抖音发布日志' }
      },
      {
        path: '/channel-accounts',
        name: 'ChannelAccountsManage',
        component: () => import('@/views/accounts/ChannelAccountsManage.vue'),
        meta: { title: '账号管理' }
      },
      {
        path: '/account-logs',
        name: 'AccountLogsManage',
        component: () => import('@/views/accounts/AccountLogsManage.vue'),
        meta: { title: '账号发布日志' }
      },
      {
        path: '/daily-publish',
        name: 'DailyPublishManage',
        component: () => import('@/views/daily/DailyPublishManage.vue'),
        meta: { title: '每日发布量' }
      },
      {
        path: '/tasks',
        name: 'TasksManage',
        component: () => import('@/views/tasks/TasksManage.vue'),
        meta: { title: '任务调度' }
      },
      {
        path: '/employees',
        name: 'EmployeesManage',
        component: () => import('@/views/employees/EmployeesManage.vue'),
        meta: { title: '员工管理' }
      },
      {
        path: '/team-docs',
        name: 'TeamDocsManage',
        component: () => import('@/views/teamDocs/TeamDocsManage.vue'),
        meta: { title: '团队文档' }
      },
      {
        path: '/team-docs/:id',
        name: 'TeamDocEditor',
        component: () => import('@/views/teamDocs/TeamDocEditor.vue'),
        meta: { title: '在线编辑' }
      },
      {
        path: '/analytics',
        name: 'AnalyticsOverview',
        component: () => import('@/views/analytics/AnalyticsOverview.vue'),
        meta: { title: '数据分析' }
      },
      {
        path: '/settings',
        name: 'SystemSettings',
        component: () => import('@/views/settings/SystemSettings.vue'),
        meta: { title: '系统设置' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 盼达新媒体系统`
  }
  
  // 检查是否需要登录
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('admin_token')
    if (!token) {
      next('/login')
      return
    }
    
    // 如果有token但用户信息为空，尝试获取用户信息
    if (!authStore.user) {
      try {
        await authStore.getUserInfo()
      } catch (error) {
        localStorage.removeItem('admin_token')
        next('/login')
        return
      }
    }
  }
  
  // 如果已登录且访问登录页，重定向到控制台
  if (to.path === '/login' && localStorage.getItem('admin_token')) {
    next('/dashboard')
    return
  }
  
  next()
})

export default router
